module.exports = new __parcel__URL__("sea-ice-thick--dataset-cover.7f548e59.jpg").toString();